"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FacilitiesModal = exports.default = void 0;

var _base = require("./base");

var _fetch = babelHelpers.interopRequireDefault(require("fetch"));

var _noty = require("noty");

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _classList = babelHelpers.interopRequireDefault(require("class-list"));

var _decorators = require("decorators");

var _userProfile = require("user-profile");

var _class, _descriptor, _temp;

var FacilitiesModal =
/*#__PURE__*/
function (_ReactModal) {
  babelHelpers.inherits(FacilitiesModal, _ReactModal);
  babelHelpers.createClass(FacilitiesModal, [{
    key: "title",
    get: function get() {
      return "";
    }
  }]);

  function FacilitiesModal(id) {
    var _this;

    babelHelpers.classCallCheck(this, FacilitiesModal);
    _this = babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(FacilitiesModal).call(this, id));
    _this.classList = ['modal', 'fade'];
    _this.modalTitleElement = 'h3';
    _this.innerWrapper = false;
    _this.withError = false;
    _this.defaultType = null;
    _this.removeOnHide = true;

    _this.setComponent(_react.default.createElement(Facilities, {
      modal: babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this))
    }));

    return _this;
  }

  return FacilitiesModal;
}(_base.ReactModal);

exports.FacilitiesModal = FacilitiesModal;
var Facilities = (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(Facilities, _Component);

  function Facilities() {
    var _babelHelpers$getProt;

    var _this2;

    babelHelpers.classCallCheck(this, Facilities);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this2 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(Facilities)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this2, "modal", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    _this2.state = {
      list: null
    };
    return _this2;
  }

  babelHelpers.createClass(Facilities, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this3 = this;

      (0, _fetch.default)('data/cart/clients').then(function (v) {
        return v.json();
      }).then(function (v) {
        return _this3.setState({
          list: v
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      if (!this.state.list) return null;
      return _react.default.createElement("div", {
        className: "modal-full overlay",
        id: "myNav"
      }, _react.default.createElement("div", {
        className: "overlay-content"
      }, _react.default.createElement("div", {
        className: "side-nav-main"
      }, _react.default.createElement("ul", null, this.state.list.map(function (_ref) {
        var id = _ref.id,
            name = _ref.name,
            selected = _ref.selected;
        return _react.default.createElement("li", {
          className: _classList.default.join('large-side-nav', selected && 'active'),
          key: id
        }, _react.default.createElement("a", {
          href: "javascript:void(0)",
          onClick: _this4.selectClient,
          "data-client-id": id
        }, _react.default.createElement("i", {
          className: "material-icons",
          "data-icon": "shopping_cart"
        }), _react.default.createElement("span", null, name)));
      })))));
    }
  }, {
    key: "selectClient",
    value: function selectClient(event) {
      var _this5 = this;

      var id = event.currentTarget.dataset.clientId;
      (0, _fetch.default)('data/cart/client', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: id
        })
      }).then(function (data) {
        return data.json();
      }).then(function (_ref2) {
        var name = _ref2.name;

        _this5.modal.hide();

        (0, _userProfile.userProfileUpdated)();

        require('components/SiteNavigation').default.clientUpdated();

        (0, _noty.showNotificationText)("Selected facility \"".concat(name, "\"."));
      });
    }
  }]);
  return Facilities;
}(_react.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "modal", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), babelHelpers.applyDecoratedDescriptor(_class.prototype, "selectClient", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "selectClient"), _class.prototype)), _class);
var instance = new FacilitiesModal('facilities-modal');
var _default = instance;
exports.default = _default;